import { useEffect, useRef } from "react";
import { isBrowser } from "../isBrowser";

type Callback = (...argv: unknown[]) => void;

export const useInterval = (
  callback: Callback,
  delay: number,
  flag?: boolean,
) => {
  const savedCallback = useRef<undefined | Callback>(undefined);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!isBrowser) return;
    const tick = () => {
      if (savedCallback.current !== undefined) {
        savedCallback.current();
      }
    };

    const id = flag || flag === undefined ? window.setInterval(tick, delay) : 0;
    return () => window.clearInterval(id);
  }, [delay, flag]);
};
